import moment from "moment"
import { connect } from "react-redux"

import {
    notificationItemDeleteRequest,
    notificationSetEditMode,
} from "../../../../actions/notification-actions"
import NotificationViewFormActionButtonsWidget from "./NotificationViewFormActionButtonsWidget"

const mapStateToProps = ({ presentation, authentication }) => {
    const currentTime = moment()
    const { workingModel } = presentation.notifications
    const startTime = workingModel.not_before
    const notYetSent =
        !workingModel.notification_triggered && !currentTime.isAfter(startTime)

    const thirtyFromStartTime = moment(startTime).add(30, "minutes")
    const isInSendingWindow =
        currentTime.isAfter(startTime) &&
        currentTime.isBefore(thirtyFromStartTime)
    const afterSendingWindow = currentTime.isAfter(thirtyFromStartTime)

    return {
        canEdit:
            authentication.permissions.indexOf("w_user") &&
            !!presentation.notifications.workingModel.id,
        canDelete:
            authentication.permissions.indexOf("w_user") &&
            !!presentation.notifications.workingModel.id,
        notYetSent,
        isInSendingWindow,
        afterSendingWindow,
        activeId: presentation.notifications.activeId,
        isDeleting: presentation.notifications.isDeletingItem,
        title: presentation.notifications.workingModel.title,
    }
}

const mapDispatchToProps = (dispatch) => ({
    onEdit: () => dispatch(notificationSetEditMode(true)),
    onDelete: (id) => dispatch(notificationItemDeleteRequest(id)),
})

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(NotificationViewFormActionButtonsWidget)
